import { Pipe, PipeTransform, inject } from "@angular/core";
import { BootstrapService } from "../bootstrap/bootstrap.service";

@Pipe({
    name: "pilotRole",
    standalone: false,
})
export class PilotRolePipe implements PipeTransform {
    private readonly _bootstrapService = inject(BootstrapService);

    transform(pilotRoleId: number, key: string): unknown {
        const pilotRoles = this._bootstrapService.pilotRoles();
        const role = pilotRoles.filter((r) => r.id === pilotRoleId)[0];
        return !role ? "N/D" : role[key];
    }
}
